import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

export interface BreadcrumbItem {
  label: string;
  routerLink?: string;
  icon?: string;
}

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <nav class="sp-breadcrumb" aria-label="breadcrumb">
      <ol>
        
        <ng-container *ngFor="let item of items; let last = last">
          <li [class.bc-active]="last" [class.bc-link]="!last">
            <a *ngIf="!last && item.routerLink" [routerLink]="item.routerLink">
              <i *ngIf="item.icon" [class]="item.icon"></i>
              {{ item.label }}
            </a>
            <span *ngIf="last">
              <i *ngIf="item.icon" [class]="item.icon"></i>
              {{ item.label }}
            </span>
          </li>
          <li *ngIf="!last" class="bc-separator" aria-hidden="true">
            <i class="pi pi-chevron-right"></i>
          </li>
        </ng-container>
      </ol>
    </nav>
  `,
  styles: [`
    .sp-breadcrumb ol {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 0.25rem;
      list-style: none;
      padding: 0.4rem 0 0.6rem;
      margin: 0;
    }
    .bc-home a,
    .bc-link a {
      color: var(--sp-primary);
      text-decoration: none;
      font-size: 0.8125rem;
      transition: opacity 0.15s;
      display: flex;
      align-items: center;
      gap: 0.3rem;
    }
    .bc-home a:hover,
    .bc-link a:hover { opacity: 0.72; }
    .bc-separator i {
      font-size: 0.6rem;
      color: var(--sp-muted);
      margin: 0 0.1rem;
    }
    .bc-active span {
      font-size: 0.8125rem;
      font-weight: 600;
      color: var(--sp-text);
      display: flex;
      align-items: center;
      gap: 0.3rem;
    }
  `]
})
export class BreadcrumbComponent {
  @Input() items: BreadcrumbItem[] = [];
  @Input() homeRoute = '/admin/dashboards';
}
